/**
 * Standardní výška skeletonu pro atributy umístěné do obsahové části řádku.
 */
export const COMMON_CONTENT_SKELETON_HEIGHT = "0.75em";
